import { styled } from '@nykaa/ui-components';

export const Popularlinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.surface10};
`;

export const Button = styled.button`
  border: none;
  background: ${({ theme }) => theme.colors.surface10};
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.subTitleMedium};
  cursor: pointer;
  justify-content: space-evenly;
  & > svg {
    margin-left: ${({ theme }) => theme.spacing.spacing60};
  }
`;
export const Row = styled.div`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
  line-height: 0;
`;

export const Wrapper = styled.div<{ isExpanded: boolean }>`
  max-width: 1200px;
  padding: 0 ${({ theme }) => theme.spacing.spacing40};
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: ${({ isExpanded }) => (isExpanded ? 'auto' : 0)};
  overflow: hidden;
  z-index: ${({ isExpanded }) => (isExpanded ? 0 : -1)};
`;
export const LinkTitle = styled.span`
  ${({ theme }) => theme.typography.labelMedium}
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const Anchor = styled.a`
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.textSecondary};
  text-decoration: none;
  margin: 0 ${({ theme }) => theme.spacing.spacing20};
  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const Dot = styled.div`
  height: 4px;
  width: 4px;
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  background: ${({ theme }) => theme.colors.textSecondary};
  display: inline-flex;
  margin: ${({ theme }) => `${theme.spacing.spacing10} ${theme.spacing.spacing20}`};
`;

export const Separator = styled.hr`
  display: block;
  margin: 0;
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
  width: 118px;
  height: 1px;
  align-self: center;
  background: ${({ theme }) => theme.colors.textSecondary};
`;

export const InlineSpace = styled.div`
  display: inline-block;
`;
